import {Component, Input, OnInit} from "@angular/core";
import {Handling} from "../../../../../../_core/classes/handling";
import {HandlingOriginEnum} from "../../../../../../_core/enum/handling-origin.enum";
import { ItemsSupplierSelections, ModuleCreationRequestResult } from "projects/ct-manager/src/app/_core/controllers/item.controller";
import { ItemSuppliersTransfer, SuppliersTransfer } from "projects/ct-manager/src/app/_core/classes/item-suppliers-transfer";

/**
 * Interfaccia per raggruppare gli handling per fornitore
 */
interface SupplierGroup {
  supplier: any;  // Oggetto fornitore
  handlings: Handling[];  // Lista di handling per questo fornitore
}

@Component({
  selector: "app-module-item-order",
  templateUrl: "./module-item-order.component.html",
  styleUrls: ["./module-item-order.component.scss"]
})
export class ModuleItemOrderComponent implements OnInit {

  @Input() handlings: Handling[] | null = null;
  @Input() model!: ModuleCreationRequestResult;
  
  matchedItems: any[] = [];
  finalItems: ItemsSupplierSelections[] = [];
  
  /**
   * Lista di handling raggruppati per fornitore
   * Viene popolata in ngOnInit
   */
  supplierGroups: SupplierGroup[] = [];

  ngOnInit(): void {
    // Raggruppa gli handling per fornitore quando il componente viene inizializzato
    this.groupHandlingsBySupplier();
  }

  /**
   * Verifica se un articolo (ItemHandling) deve essere mostrato negli header dei fornitori.
   * Un articolo NON deve essere mostrato se:
   * - Appare in model.ItemSuppliers (significa che ha più fornitori disponibili)
   * 
   * @param itemHandling L'ItemHandling da verificare
   * @returns true se l'articolo deve essere mostrato nell'header, false se ha selezione multipla
   */
  shouldShowInSupplierHeader(itemHandling: any): boolean {
    // Se non c'è model o ItemSuppliers, mostra tutto
    if (!this.model?.ItemSuppliers || this.model.ItemSuppliers.length === 0) {
      return true;
    }

    // Verifica se questo articolo è presente in ItemSuppliers (ha più fornitori)
    const hasMultipleSuppliers = this.model.ItemSuppliers.some(
      item => item.ItemOid === itemHandling.Item?.Oid
    );

    // Se ha più fornitori, NON mostrarlo nell'header
    return !hasMultipleSuppliers;
  }

  /**
   * Verifica se un gruppo di fornitori ha almeno un articolo da mostrare.
   * Questo serve per nascondere l'header del fornitore se tutti i suoi articoli
   * sono stati filtrati (perché hanno più fornitori disponibili).
   * 
   * @param group Il gruppo di fornitori da verificare
   * @returns true se il gruppo ha almeno un articolo visibile
   */
  hasVisibleItems(group: SupplierGroup): boolean {
    return group.handlings.some(handling => 
      handling.ItemHandlings?.some(itemHandling => 
        this.shouldShowInSupplierHeader(itemHandling)
      )
    );
  }

  /**
   * Raggruppa gli handling per fornitore.
   * Crea un array di gruppi dove ogni gruppo contiene:
   * - Il fornitore (preso da handling.SupplierFrom)
   * - Tutti gli handling associati a quel fornitore
   */
  private groupHandlingsBySupplier(): void {
    if (!this.handlings || this.handlings.length === 0) {
      return;
    }
debugger
    // Verifica se sono ordini (hanno SupplierFrom) o movimentazioni (hanno LocationFrom)
    const isSupplierOrder = this.handlings[0].HandlingOrigin === HandlingOriginEnum.Supplier;

    if (!isSupplierOrder) {
      // Per le movimentazioni non raggruppiamo, manteniamo l'ordine originale
      return;
    }

    // Mappa per raggruppare per fornitore
    const supplierMap = new Map<number, SupplierGroup>();

    this.handlings.forEach(handling => {
      const supplier = handling.SupplierFrom;
      
      if (supplier && supplier.Oid) {
        if (!supplierMap.has(supplier.Oid)) {
          // Crea un nuovo gruppo per questo fornitore
          supplierMap.set(supplier.Oid, {
            supplier: supplier,
            handlings: []
          });
        }
        
        // Aggiungi l'handling al gruppo del fornitore
        supplierMap.get(supplier.Oid)!.handlings.push(handling);
      }
    });

    // Converti la mappa in array
    this.supplierGroups = Array.from(supplierMap.values());
  }

  /**
   * Verifica se c'è un solo fornitore
   */
  hasSingleSupplier(): boolean {
    return this.supplierGroups.length === 1;
  }

  getSourceFrom(handling: Handling): string | null | undefined {
    return handling.HandlingOrigin === HandlingOriginEnum.Location ? 
      handling.LocationFrom?.Name : 
      handling.SupplierFrom?.ReferenceName;
  }

  getSourceIcon(handling: Handling): string | null | undefined {
    return handling.HandlingOrigin === HandlingOriginEnum.Location ? 
      'swap_horiz' : 
      'local_shipping';
  }

  onSupplierChange(item : ItemSuppliersTransfer, newSupplier: SuppliersTransfer) {
    const existingItem = this.finalItems.find(itemFinal => itemFinal.ItemOid === item.ItemOid);

    if (existingItem) {
      existingItem.SupplierOid = newSupplier.Oid;
    } else {
      this.finalItems.push(new ItemsSupplierSelections(item.ItemOid, newSupplier.Oid));
    }

    this.model.ItemsSupplierSelections = this.finalItems;
  }
}
